import React from "react";

const ProvinceIcon = ({ width, height, color }) => {
	return (
		<svg
			width={width || "31"}
			height={height || "31"}
			viewBox="0 0 31 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M27.0199 16.8486H27.2691V14.2565C27.2691 13.2115 26.8498 12.2094 26.1034 11.4705C25.357 10.7316 24.3446 10.3165 23.289 10.3165H14.3075V5.80628H21.5629V0H13.6204C13.2193 0 12.8346 0.15774 12.551 0.438517C12.2673 0.719295 12.108 1.10011 12.108 1.49719V10.3165H7.70889C6.65329 10.3165 5.64093 10.7316 4.89451 11.4705C4.14809 12.2094 3.72876 13.2115 3.72876 14.2565V16.8486H3.98013C2.92454 16.8486 1.91217 17.2637 1.16575 18.0026C0.419334 18.7414 0 19.7436 0 20.7885V23.3806H2.33047V38H11.7812V27.9375C11.7812 25.4211 12.8998 23.3806 15.4471 23.3806C17.9892 23.3806 19.1078 25.4211 19.1078 27.9375V38H28.5585V23.3806H31V20.7885C31 20.2711 30.8971 19.7588 30.697 19.2808C30.497 18.8028 30.2038 18.3684 29.8342 18.0026C29.4647 17.6367 29.0259 17.3465 28.543 17.1485C28.0601 16.9505 27.5425 16.8486 27.0199 16.8486ZM22.5956 20.3074C22.419 20.4825 22.1794 20.581 21.9295 20.5812H9.06632C8.81631 20.5812 8.57654 20.4829 8.39976 20.3079C8.22298 20.1329 8.12366 19.8955 8.12366 19.648C8.12366 19.4005 8.22298 19.1632 8.39976 18.9882C8.57654 18.8132 8.81631 18.7149 9.06632 18.7149H21.9295C22.1158 18.715 22.2979 18.7698 22.4528 18.8724C22.6076 18.9749 22.7283 19.1206 22.7996 19.291C22.8709 19.4614 22.8896 19.6489 22.8533 19.8298C22.8169 20.0108 22.7273 20.1769 22.5956 20.3074Z"
				fill={color || "white"}
			/>
		</svg>
	);
};

export default ProvinceIcon;
